import { Bold, Italic, Strikethrough, Code, Smile } from 'lucide-react';

interface FormattingToolbarProps {
  onFormat: (formatType: 'bold' | 'italic' | 'strikethrough' | 'code') => void;
  onEmojiClick: () => void;
  disabled?: boolean;
}

export default function FormattingToolbar({ onFormat, onEmojiClick, disabled = false }: FormattingToolbarProps) {
  const buttons = [
    {
      type: 'bold' as const,
      icon: Bold,
      title: 'Negrito (Ctrl+B)',
      label: '*texto*',
    },
    {
      type: 'italic' as const,
      icon: Italic,
      title: 'Itálico (Ctrl+I)',
      label: '_texto_',
    },
    {
      type: 'strikethrough' as const,
      icon: Strikethrough,
      title: 'Tachado',
      label: '~texto~',
    },
    {
      type: 'code' as const,
      icon: Code,
      title: 'Monoespaçado',
      label: '```texto```',
    },
  ];

  return (
    <div className="flex items-center gap-1 p-2 bg-bg-1 border border-bg-3 rounded-md">
      {/* Formatting Buttons */}
      {buttons.map((button) => (
        <button
          key={button.type}
          type="button"
          onClick={() => onFormat(button.type)}
          disabled={disabled}
          className="p-2 hover:bg-bg-3 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          title={button.title}
        >
          <button.icon size={16} className="text-text-2" />
        </button>
      ))}

      {/* Divider */}
      <div className="w-px h-6 bg-bg-3 mx-1" />

      {/* Emoji Button */}
      <button
        type="button"
        onClick={onEmojiClick}
        disabled={disabled}
        className="p-2 hover:bg-bg-3 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title="Adicionar Emoji"
      >
        <Smile size={16} className="text-text-2" />
      </button>

      {/* Help Text */}
      <div className="ml-auto flex items-center gap-2 text-xs text-text-3">
        <span>Dica: Selecione o texto antes de aplicar formatação</span>
      </div>
    </div>
  );
}
